import React from 'react';
import style from './ComponentConfigurations.module.css';

/**
 * Breadcrumbs da caixa de configuração de componentes
 * @param {*} props
 * @returns
 */
export function ComponentConfigurationBreadCrumbs(props) {
  return (
    <span className={style.BreadCrumb}>
      Componentes
      /
      {props.title}
      /
      {props.label}
    </span>
  );
}

export default ComponentConfigurationBreadCrumbs;
